import { createContext } from 'react';

export const IsEmptyContext = createContext(null);
